import React, { createContext, useContext } from 'react';
import type { CurrencyCode } from '@99designs/i18n';

export interface ExchangeRate {
    rate: number;
    currency: CurrencyCode;
}

interface LocalExchangeRateProviderProps {
    children: React.ReactNode;
    currency: CurrencyCode;
    exchangeRate: number;
}

interface StubExchangeRateProviderProps
    extends Omit<LocalExchangeRateProviderProps, 'currency' | 'exchangeRate'> {
    exchangeRate: ExchangeRate;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LocalExchangeRateContext = createContext<ExchangeRate>(null as any);

export function LocalExchangeRateProvider({
    children,
    currency,
    exchangeRate,
}: LocalExchangeRateProviderProps) {
    return (
        <LocalExchangeRateContext.Provider value={{ rate: exchangeRate, currency }}>
            {children}
        </LocalExchangeRateContext.Provider>
    );
}

export function StubExchangeRateProvider({
    exchangeRate,
    children,
}: StubExchangeRateProviderProps) {
    return (
        <LocalExchangeRateContext.Provider value={exchangeRate}>
            {children}
        </LocalExchangeRateContext.Provider>
    );
}

export function useLocalExchangeRate(): ExchangeRate {
    return useContext(LocalExchangeRateContext);
}
